import React, { useState } from "react";
import "./styles.scss";

import {
  AccordionDetails,
  Accordion,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InstallationRequirement from "../../bundleList/installationRequirement";

const CartProductsList = (props) => {
  const { response, data } = props;
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  let temp = response?.filtered_cart && Object.entries(response?.filtered_cart);
  let formattedLength0 = ("0" + temp[0]?.[1]?.length).slice(-2);
  let formattedLength1 = ("0" + temp[1]?.[1]?.length).slice(-2);
  let data1 = temp &&
    temp[0]?.[0] && {
      id: 1,
      title: temp && temp[0]?.[0],
      total_points: temp && formattedLength0,
    };
  let data2 = temp &&
    temp[1]?.[0] && {
      id: 2,
      title: temp && temp[1]?.[0],
      total_points: temp && formattedLength1,
    };
  const dataArray = [];

  if (data1) {
    dataArray.push({ ...data1 });
  }
  if (data2) {
    dataArray.push({ ...data2 });
  }
  // Format as currency with CAD currency symbol
  const formattedPrice = (price) => {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD",
    }).format(price);
  };


  return (
    <div className="cart-produclist-container">
      <h3>My Cart</h3>
      <div className="accordion-container">
        {dataArray?.map((item, index) => {
          return (
            <Accordion
              expanded={expanded === item?.id}
              onChange={handleChange(item?.id)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0 }}
                  className="title"
                >
                  {item?.title}
                </Typography>
                <Typography sx={{ color: "text.secondary" }} className="points">
                  Total products : {item?.total_points}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {temp &&
                    temp[index] &&
                    temp[index]?.[1]?.length > 0 &&
                    temp[index][1].map((itm, idx) => {
                    
    
                      const isLastProduct = idx === temp[index]?.[1].length - 1;


                      return (
                        <div className="product-details"
                        style={{
                           borderBottom: !isLastProduct ? '1px solid #d4d4d4' : 'none'
                        }}
                        >
                          <div className="image">
                            <img
                              src={
                                item?.variation_image
                                  ? itm?.variation_image
                                  : itm?.product_image
                              }
                              alt={`product${idx}`}
                            />
                          </div>
                          <div className="details">
                            <p className="title">{itm?.product_name}</p>
                            <p className="accessory">
                              {itm?.variation_name?.map((i) => {
                                return (
                                  <>
                                    {i?.attribute_name?.length &&
                                      i?.option_name?.length && (
                                        <span className="accessory-tile">
                                          {i?.attribute_name}
                                          <span className="accessory-info">
                                            {i?.option_name
                                              ? `: ${i?.option_name}`
                                              : ""}
                                          </span>
                                        </span>
                                      )}
                                  </>
                                );
                              })}
                            </p>
                            <div className="amount">
                              <span className="offer">
                                ${itm?.display_price} {itm?.currency}
                              </span>
                              {itm?.display_price !==
                              itm?.display_regular_price ? (
                                <span className="cross-amount">
                                  {formattedPrice(itm?.display_regular_price)}{" "}
                                  {itm?.currency}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </Typography>

                {/* <InstallationRequirement
                  data={{
                    description: "",
                    checked_content: data?.installation_content,
                    price: data?.install_price,
                    currency_symbol: data?.currency_symbol,
                    title: "Installation Requirements",
                  }}
                  checked={true}
                  isMycart={true}
                  identity="installation"
                />

                <InstallationRequirement
                  data={{
                    description: data?.fall_prevention_program,
                    checked_content: data?.home_consultation,
                    title: "Fall Prevention Program",
                  }}
                  checked={true}
                  isMycart={true}
                  identity="fall_prevention"
                  // identity="installation"
                /> */}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};

export default CartProductsList;
